import './InformationBox.scss';

import { Stack } from 'react-bootstrap';

const InformationBox = () => {
  return (
    <Stack gap={3} className='rounded-3 flex-grow-0 mt-4 mb-3 information-box-container'>
      <p className='fw-semibold'>
        Aligned with our commitment to accessible genetic testing, MyOme offers flexible billing options, including a
        Financial Assistance Program (FAP).
        <br />
        <br />
        To apply, complete the form below.
      </p>
      <p className='fs-xs'>
        Financial assistance is not available for all genetic testing services. Financial assistance is considered on a
        case-by-case basis only. Financial assistance is not available to groups of patients. Each person requesting
        financial assistance for genetic testing must complete this form. Financial assistance is for testing that is
        billed through insurance or for uninsured patients.
      </p>
      <div>
        <p className='mb-1 fw-bold fs-xs'>Contact us with questions:</p>
        <p className='fs-xs'>
          If you would like to speak with MyOme about a payment plan or for support with your bill, please contact us
          at&nbsp;
          <a href='mailto:support@myome.com' className='fw-semibold'>
            support@myome.com
          </a>
          .
        </p>
      </div>
    </Stack>
  );
};

export default InformationBox;
